import { Injectable, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../shared/services/api.service';

export enum InstitutionType {
  all = 0,
  bank = 1,
  creditUnion = 2,
  other = 3
}

export interface Institution {
  institutionType: InstitutionType;
  iid: number;
  identifier: number;
  name: string;
  city: string;
  state: string;
  label: string;
  active: boolean;
  lastReportingDate?: Date;
  dateLastViewed?: Date;
}

export interface UserInstitution {
  iid: number;
  dateLastViewed: Date;
}

export interface SubscriptionProductModel {
  organizationId: string;
  productTierId: string;
  productName: string;
  subscriptionEndDate: Date;
  dateCreated: Date;
  stripeId: string;
  subscriptionIsCanceled: boolean;
  term: number;
}


@Injectable({
  providedIn: 'root'
})
export class InstitutionService {
  private apiService = inject(ApiService);

  private _institutions: Institution[] = [];
  readonly institutionsFetched = signal(false);

  constructor() {
    this.apiService.get<Institution[]>('/api/institution').subscribe(institutions => {
      this._institutions = institutions;
      this.institutionsFetched.set(true);
    });
  }

  public getInstitution(iid: number): Institution | undefined {
    return this._institutions.find(i => i.iid === iid);
  }

  public getInstitutions(): Institution[] {
    return this._institutions;
  }

  public searchInstitutions(search: string): Institution[] {
    const searchTerms = search.split(' ');
    const list = this._institutions.filter(i => {
      let match = true;
      searchTerms.forEach(s => {
        if (!new RegExp('\\b' + s, 'i').test(i.label)) {
          match = false;
        }
      });
      return match;
    });
    list.sort((a, b) => a.name?.localeCompare(b.name) || a.city?.localeCompare(b.city) || a.state?.localeCompare(b.state));
    return list;
  }

  public getUserInstitutions(): Observable<UserInstitution[]> {
    return this.apiService.get<UserInstitution[]>('/api/user/institution');
  }

  public getOrganizationSubscriptions(organizationId: string): Observable<SubscriptionProductModel[]> {
    return this.apiService.get<SubscriptionProductModel[]>(`/api/institution/${organizationId}`);
  }

}
